<template>
  <customerTemplate
    v-if="templatePage && pageTypeId"
    :key="new Date()"
    :from-type="3"
    :show-edit-content-button="false"
    :show-edit-components-button="false"
    :show-delete-components-button="false"
    :show-insert-components-button="false"
    :show-sort-components-button="false"
    :template-page="templatePage"
  >
  </customerTemplate>
  <div v-else class="system-maintenance">
    <el-empty description="您预览的栏目未维护任何内容，请先去维护。" />
  </div>
</template>

<script setup>
// #region 引用
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import customerTemplate from '../components/Template.vue';

// #endregion
// #region props/emit

// #endregion

// #region 变量/常量
const route = useRoute();
const configInfo = ref({}); // 配置信息
const columnInfo = ref({}); // 当前栏目信息
const configPageList = ref([]); // 配置页面列表
const pageTypeId = ref(Number(route.params.pageTypeId));

const templatePage = ref([]); // 当前页面信息
// 当前路由栏目id
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 获取栏目信息
 * SSR 期间同步读取数据（父组件 onServerPrefetch 已设置）
 */
if (import.meta.env.SSR) {
  const ssrContext = useSSRContext();
  configInfo.value = ssrContext.initialState?.data?.current?.configInfo;
  configPageList.value = ssrContext.initialState?.data?.current?.configPageList;
  columnInfo.value = ssrContext.initialState?.data?.current?.columnInfo;
  templatePage.value = configPageList.value?.find(
    (item) => item.id === pageTypeId.value,
  );
  if (ssrContext.initialState?.data?.current) {
    ssrContext.initialState.data.current.templatePage = templatePage.value;
  }
}

// 客户端数据恢复 - 必须在 useHead 之前，否则会覆盖 SSR 标题
if (!import.meta.env.SSR) {
  const ssrInitialState = useSSRInitialStateStore();
  configInfo.value = ssrInitialState.data.current.configInfo;
  configPageList.value = ssrInitialState.data.current.configPageList;
  columnInfo.value = ssrInitialState.data.current.columnInfo;
  templatePage.value = ssrInitialState.data.current.templatePage;
}

// SEO - 在 setup 顶层使用 computed，数据更新后自动响应
// 注意：必须在数据恢复之后调用，否则会用空值覆盖 SSR 标题
useHead({
  title: computed(
    () =>
      columnInfo.value?.columnName
        ? `${columnInfo.value.columnName} - ${configInfo.value?.homeTitle || ''}`
        : '',
  ),
  meta: [
    {
      name: 'keywords',
      content: computed(() => columnInfo.value?.columnName || ''),
    },
    {
      name: 'description',
      content: computed(() => columnInfo.value?.digest || ''),
    },
  ],
});

// #endregion
</script>

<style lang="scss" scoped>
@media screen and (device-width > 1180px) {
  .system-maintenance {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style scoped lang="scss">
@media screen and (device-width <= 1180px) {
  .system-maintenance {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
